/* eslint-disable camelcase */
import { Pagination } from "react-bootstrap";
import PropTypes from "prop-types";
import { useCallback } from "react";

const PaginationWithPage = ({
	pager,
	onChange
}) => {

	const handleFirstPage = useCallback(() => {
		onChange(1);
	}, [onChange]);

	const handlePreviousPage = useCallback(() => {
		onChange(pager.page - 1);
	}, [pager, onChange]);

	const handleNextPage = useCallback(() => {
		onChange(pager.page + 1);
	}, [pager, onChange]);

	const handleLastPage = useCallback(() => {
		onChange(pager.total_pages);
	}, [pager, onChange]);

	return (
		<Pagination>
			<Pagination.First disabled={pager.page <= 1} onClick={handleFirstPage} />
			<Pagination.Prev disabled={pager.page <= 1} onClick={handlePreviousPage} />
			<Pagination.Next disabled={pager.page >= pager.total_pages} onClick={handleNextPage} />
			<Pagination.Last disabled={pager.page >= pager.total_pages} onClick={handleLastPage} />
		</Pagination>
	);
};

PaginationWithPage.propTypes = {
	onChange: PropTypes.func.isRequired,
	pager: PropTypes.shape({
		page: PropTypes.number,
		total_pages: PropTypes.number
	}).isRequired
};

export default PaginationWithPage;
